const SETUPS = [
  { sym: "BTC", side: "LONG", grade: "A", entry: "80,920", stop: "80,410", tp: "81,940", rr: "2.0R", why: "Squeeze release · buyers absorbing at VAL · regime: compression" },
  { sym: "SOL", side: "SHORT", grade: "A", entry: "102.35", stop: "103.10", tp: "100.85", rr: "2.0R", why: "Failed breakout · sell imbalance stack · funding hot" },
  { sym: "LINK", side: "LONG", grade: "B+", entry: "14.62", stop: "14.41", tp: "15.04", rr: "2.0R", why: "Volume surge 2.4× · OI rising with price" },
];

const RESOLVED = [
  ["13:15", "ETH", "LONG", "A", "+2.0R", "Target hit"],
  ["12:45", "AVAX", "SHORT", "A", "+0.4R", "Partial banked · stop → BE"],
  ["12:30", "DOGE", "LONG", "B+", "−1.0R", "Stopped out"],
  ["11:00", "BNB", "SHORT", "A", "+2.0R", "Target hit"],
];

export const SetupsMock = () => (
  <div data-testid="mock-setups">
    <div className="mb-3 flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.2em] text-[#5A6170]">
      <span>Engine · live setups</span><span>176 markets · 15m close</span>
    </div>
    <SetupCards />
    <div className="mt-5 hidden border border-white/[0.06] lg:block">
      <div className="grid grid-cols-[70px_80px_80px_60px_80px_1fr] border-b border-white/[0.06] px-5 py-2.5 font-mono text-[9px] uppercase tracking-[0.2em] text-[#5A6170]">
        <span>Time</span><span>Market</span><span>Side</span><span>Grade</span><span>Result</span><span>Status · published to verify</span>
      </div>
      {RESOLVED.map((r) => (
        <div key={r[0] + r[1]} className="grid grid-cols-[70px_80px_80px_60px_80px_1fr] border-b border-white/[0.04] px-5 py-2.5 font-mono text-[12px] last:border-b-0">
          <span className="text-[#5A6170]">{r[0]}</span><span className="text-[#ECEBE4]">{r[1]}</span>
          <span className={r[2] === "LONG" ? "text-[#BACD1C]/80" : "text-[#FF4D5A]/90"}>{r[2]}</span><span className="text-[#9DA3AE]">{r[3]}</span>
          <span className={r[4].startsWith("+") ? "text-[#BACD1C]" : "text-[#FF4D5A]"}>{r[4]}</span><span className="text-[#7D8390]">{r[5]}</span>
        </div>
      ))}
    </div>
  </div>
);

const SetupCards = () => (
  <div className="grid gap-px bg-white/[0.06] p-px sm:grid-cols-3">
    {SETUPS.map((s) => (
      <div key={s.sym} className="bg-[#0B0C0F] p-5 font-mono">
        <div className="flex items-center justify-between">
          <span className="text-base font-semibold text-[#ECEBE4]">{s.sym}<span className="text-[#5A6170]">/USDT</span></span>
          <span className={`border px-2 py-0.5 text-[10px] tracking-[0.18em] ${s.side === "LONG" ? "border-[#BACD1C]/40 text-[#BACD1C]" : "border-[#FF4D5A]/40 text-[#FF4D5A]"}`}>{s.side}</span>
        </div>
        <div className="mt-1 text-[10px] uppercase tracking-[0.2em] text-[#5A6170]">Grade {s.grade} · 15m · {s.rr}</div>
        <div className="mt-5 grid grid-cols-3 gap-2 text-[11px]">
          {[["Entry", s.entry], ["Stop", s.stop], ["Target", s.tp]].map(([k, v]) => (
            <div key={k}><div className="text-[9px] uppercase tracking-[0.18em] text-[#5A6170]">{k}</div><div className="mt-1 tabular-nums text-[#ECEBE4]">{v}</div></div>
          ))}
        </div>
        <p className="mt-5 border-t border-white/[0.06] pt-4 text-[11px] leading-relaxed text-[#9DA3AE]">{s.why}</p>
      </div>
    ))}
  </div>
);

const SCORES = [["Liquidity & depth", 86], ["Holder concentration", 41], ["Unlock / supply risk", 58], ["Dev & on-chain activity", 74], ["Narrative momentum", 69]];

const PEERS = [["ETH", 72, "Worth watching", "Accumulate on regime confirmation"], ["SOL", 68, "Worth watching", "Strong activity, crowded funding"], ["LINK", 64, "Neutral", "Steady accumulation, low narrative"], ["AVAX", 49, "Caution", "Large unlock in 3 weeks"]];

export const ResearchMock = () => (
  <div>
    <ResearchCard />
    <div className="mt-5 hidden border border-white/[0.06] lg:block" data-testid="mock-research-peers">
      <div className="grid grid-cols-[80px_80px_150px_1fr] border-b border-white/[0.06] px-5 py-2.5 font-mono text-[9px] uppercase tracking-[0.2em] text-[#5A6170]"><span>Asset</span><span>Score</span><span>Verdict</span><span>Key driver</span></div>
      {PEERS.map(([a, sc, v, k]) => (
        <div key={a} className="grid grid-cols-[80px_80px_150px_1fr] items-center border-b border-white/[0.04] px-5 py-2.5 font-mono text-[12px] last:border-b-0">
          <span className="text-[#ECEBE4]">{a}</span><span className={sc >= 60 ? "text-[#BACD1C]/90" : "text-[#FFB224]"}>{sc}</span><span className="text-[#9DA3AE]">{v}</span><span className="text-[#7D8390]">{k}</span>
        </div>
      ))}
    </div>
  </div>
);

const ResearchCard = () => (
  <div data-testid="mock-research" className="grid gap-px bg-white/[0.06] p-px md:grid-cols-[1fr_1.4fr]">
    <div className="bg-[#0B0C0F] p-6 font-mono">
      <div className="text-[10px] uppercase tracking-[0.22em] text-[#5A6170]">TQ Research · ETH</div>
      <div className="mt-4 flex items-baseline gap-2"><span className="font-display text-6xl font-semibold tracking-tight text-[#ECEBE4]">72</span><span className="text-sm text-[#5A6170]">/100</span></div>
      <div className="mt-2 inline-block border border-white/20 px-2 py-0.5 text-[10px] uppercase tracking-[0.18em] text-[#ECEBE4]">Worth watching</div>
      <p className="mt-5 text-[11px] leading-relaxed text-[#9DA3AE]">Strong liquidity and dev activity; supply unlocks and concentration cap the score. Thesis: accumulate on regime confirmation.</p>
    </div>
    <div className="space-y-4 bg-[#0B0C0F] p-6 font-mono">
      {SCORES.map(([k, v]) => (
        <div key={k}>
          <div className="flex justify-between text-[11px]"><span className="text-[#9DA3AE]">{k}</span><span className="tabular-nums text-[#ECEBE4]">{v}</span></div>
          <div className="mt-1.5 h-[3px] bg-white/[0.06]"><div className={`h-full ${v >= 70 ? "bg-[#BACD1C]/70" : v >= 50 ? "bg-white/40" : "bg-[#FF4D5A]/70"}`} style={{ width: `${v}%` }} /></div>
        </div>
      ))}
    </div>
  </div>
);

const NEWS = [
  ["13:42", "HIGH", "US CPI prints below consensus; risk assets bid", "BTC +1.4% in 4m"],
  ["13:18", "MED", "Large ETH transfer to exchange from early wallet", "ETH −0.6% in 9m"],
  ["12:57", "HIGH", "Exchange announces SOL perp leverage cut", "SOL −2.1% in 12m"],
  ["12:31", "LOW", "Layer-2 network upgrade goes live on mainnet", "no reaction"],
  ["12:04", "MED", "Spot ETF flows turn positive for third day", "BTC +0.5% in 15m"],
  ["11:40", "HIGH", "Large stablecoin mint on exchange wallet", "BTC +0.8% in 20m"],
  ["11:12", "LOW", "Token unlock scheduled for next week confirmed", "no reaction"],
];

export const NewsMock = () => (
  <div data-testid="mock-news" className="bg-[#0B0C0F] font-mono">
    {NEWS.map(([t, imp, head, react], i) => (
      <div key={t} className={`grid grid-cols-[52px_52px_1fr] items-start gap-3 px-5 py-4 text-[12px] sm:grid-cols-[60px_60px_1fr_150px] ${i ? "border-t border-white/[0.05]" : ""}`}>
        <span className="tabular-nums text-[#5A6170]">{t}</span>
        <span className={`text-[10px] tracking-[0.16em] ${imp === "HIGH" ? "text-[#FFB224]" : "text-[#5A6170]"}`}>{imp}</span>
        <span className="text-[#ECEBE4]">{head}</span>
        <span className={`col-start-3 text-[11px] sm:col-start-auto sm:text-right ${react.includes("+") ? "text-[#BACD1C]/80" : react.includes("−") ? "text-[#FF4D5A]/90" : "text-[#5A6170]"}`}>{react}</span>
      </div>
    ))}
  </div>
);
